import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import getAppConfig from '../config/AppConfig';

export const FooterSection = () => (
    <div>
        <div className="link-block-container">
            <div className="rc-flex-container-center">
                <div>
                    <p className="link-block-text">Resources</p>
                    <div className="rc-flex-container-center rc-mb-1">
                        <div className="rc-flex-container-center-r2c">
                            <a className="block-link" href={`${getAppConfig("siteUrl")}/resources/type-of-events`}>Type of Events</a>
                            <a className="block-link" href={`${getAppConfig("siteUrl")}/resources/features`}>Features</a>
                        </div>
                        <div className="rc-flex-container-center-r2c">
                            <a className="block-link" href={`${getAppConfig("siteUrl")}/resources/contribution-list`}>Contribution List</a>
                            <a className="block-link" href={`${getAppConfig("siteUrl")}/resources/helping-hands`}>Helping Hands List</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="footer-container">
            <div className="rc-flex-container-center">
            <div>
                <div className="rc-flex-container-center rc-mb-1">
                    <a className="block-link" href={`${getAppConfig("siteUrl")}/resources/about-us`}>About Us</a>
                    <Link to="/privacy-policy"  className="footer-link">Privacy Policy</Link>
                    <Link to="/contact-form"  className="footer-link">Contact Us</Link>
                </div>
                <p className="footer-text"> Copyright &copy; PitchInClub {new Date().getFullYear()}</p>
            </div>
            </div>
        </div>
    </div>
)

// export default FooterSection;


// WEBPACK FOOTER //
// ./src/components/FooterSection.js